// extracted by mini-css-extract-plugin
export default {"button":"SingInButton-module--button--98It5","wrapper":"SingInButton-module--wrapper--Eo89M","disabled":"SingInButton-module--disabled--XFD1I"};